/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * An error due to the client not being associated to any Roblox account
while attempting to perform an operation that uses Roblox account
information to make authorization decisions.
 * @export
 * @interface RobloxLinkRequiredErrorResponseContent
 */
export interface RobloxLinkRequiredErrorResponseContent {
    /**
     * Message with details about the error
     * @type {string}
     * @memberof RobloxLinkRequiredErrorResponseContent
     */
    message: string;
}


/**
 * Check if a given object implements the RobloxLinkRequiredErrorResponseContent interface.
 */
export function instanceOfRobloxLinkRequiredErrorResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    return isInstance;
}

export function RobloxLinkRequiredErrorResponseContentFromJSON(json: any): RobloxLinkRequiredErrorResponseContent {
    return RobloxLinkRequiredErrorResponseContentFromJSONTyped(json, false);
}

export function RobloxLinkRequiredErrorResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): RobloxLinkRequiredErrorResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': json['message'],
    };
}

export function RobloxLinkRequiredErrorResponseContentToJSON(value?: RobloxLinkRequiredErrorResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

